import { FormattedEvent } from '@eventbrite/event-renderer';
import classNames from 'classnames';
import React from 'react';
import { FeatureFlags } from '../../types/index';
import DiscoverVerticalEventCard from '../DiscoverEventCard/DiscoverVerticalEventCard';
import { SeeMoreButton } from '../SeeMoreButton';

const getCards = ({
    isSmallCity,
    cards,
    isAuthenticated,
    onTrackClickInternal,
    affCode,
    locale,
    statsigLocationString,
}: {
    isSmallCity: boolean;
    cards: FormattedEvent[];
    locale: string;
    isAuthenticated: boolean;

    onTrackClickInternal?: Function;
    affCode?: string;
    statsigLocationString: string;
}) => {
    const cardsArrayLength = cards.length;
    return cards.map((event, index: number) => {
        const shouldTrimOddCard =
            cardsArrayLength % 2 === 1 &&
            index === cardsArrayLength - 1 &&
            !isSmallCity;
        const classes = classNames(
            'eds-l-pad-all--3',
            'eds-g-cell',
            'eds-g-cell--has-overflow',
            'eds-g-cell-md-4-12',
            'eds-g-cell-sm-6-12',
            'eds-g-cell-1-1',
            {
                //hide extraneous cards
                'eds-show-up-sm': index > 2 && !isSmallCity,
                //trim odd card so doesnt look wierd on medium breakpoints
                'eds-hide-sm eds-hide-sw eds-hide-mn': shouldTrimOddCard,
            },
        );

        return (
            <div className={classes} key={event.id}>
                <DiscoverVerticalEventCard
                    event={event}
                    statsigLocationString={statsigLocationString}
                    isAuthenticated={isAuthenticated}
                    affCode={affCode}
                    locale={locale}
                    onClick={() => {
                        onTrackClickInternal?.(
                            index,
                            event.id,
                            event.ticketsBy,
                        );
                    }}
                />
            </div>
        );
    });
};

export const BigEventCardGroup = ({
    cards,
    linkUrl,
    isAuthenticated,
    isSmallCity,
    title,
    onTrackClickInternal,
    affCode,
    locale,
    statsigLocationString,
}: {
    cards: FormattedEvent[];
    linkUrl?: string;
    isAuthenticated: boolean;
    isSmallCity: boolean;
    locale: string;
    title?: string;
    onTrackClickInternal?: Function;
    experiments: any;
    featureFlags: FeatureFlags;
    affCode?: string;
    statsigLocationString: string;
}) => (
    <div className="eds-g-group">
        {getCards({
            isSmallCity,
            cards,
            isAuthenticated,
            onTrackClickInternal,
            affCode,
            locale,
            statsigLocationString,
        })}
        <div className="eds-show-down-sn eds-align--center">
            <div className="eds-g-cell">
                <SeeMoreButton linkUrl={linkUrl || ''} title={title || ''} />
            </div>
        </div>
    </div>
);

export default BigEventCardGroup;
